import { createStoreModule } from '@/_core/fluxstore';
import { IAction } from '@/_core/fluxstore/types';
import { AccountState } from './types';

const initState = () => {
    const a = new AccountState();
    return a;
};

export const useAccountStore = createStoreModule<AccountState, IAction<AccountState>>(initState, 'root-account');
